import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getMerchantCountryKey } from '@/selectors/merchant';
import InformationContainer from './InformationContainer';

const tPrefix = 'products-fe.pages.whats_next_page.in_review';

const Review = ({ merchantCountry, t }) => {
  const tPrefixList = `${tPrefix}.content.list`;

  return (
    <InformationContainer
      tPrefix={tPrefix}
      tPrefixList={tPrefixList}
      merchantCountry={merchantCountry}
      hasFooter={merchantCountry === 'US'}
      t={t}
    />
  );
};

Review.propTypes = {
  merchantCountry: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

export default connect(state => ({
  merchantCountry: getMerchantCountryKey(state),
}))(Review);
